export default {
      id: "vague-filariane-usage",
      viewBox: "0 0 15 5",
      url: "../dist/images/" + "sprite.svg#vague-filariane-usage",
      toString: function () {
        return this.url;
      }
    }